import type { Permission } from '@itc/shared';
import { modules } from '../modules.ts';

// The admin panel's sections (plan 1C Assumption 13): core's first, then each web
// module's under its title. Each is gated by its own permission.

export interface AdminLink {
  label: string;
  to: string;
  permission: Permission;
}

export interface AdminGroup {
  title: string;
  links: AdminLink[];
}

export const CORE_SECTIONS: readonly AdminLink[] = [
  { label: 'Users', to: '/admin/users', permission: 'core.admin.users' },
  { label: 'Groups', to: '/admin/groups', permission: 'core.admin.groups' },
  { label: 'Role links', to: '/admin/role-links', permission: 'core.admin.roles' },
  { label: 'Permissions', to: '/admin/permissions', permission: 'core.admin.groups' },
  { label: 'Settings', to: '/admin/settings/core', permission: 'core.admin.settings' },
  { label: 'Audit log', to: '/admin/audit', permission: 'core.audit.view' },
  { label: 'System', to: '/admin/system', permission: 'core.system.view' },
];

/** The sections a user may open, grouped. */
export function adminGroups(can: (permission: string) => boolean): AdminGroup[] {
  const groups: AdminGroup[] = [{ title: 'ITC Web', links: CORE_SECTIONS.filter((link) => can(link.permission)) }];
  for (const module of modules) {
    const links = (module.admin ?? []).filter((section) => can(section.permission)).map((section) => ({ label: section.label, to: section.path, permission: section.permission }));
    if (links.length > 0) groups.push({ title: module.title ?? module.name, links });
  }
  return groups.filter((group) => group.links.length > 0);
}

/** Where /admin goes: the first section the user may open, or null for none. */
export function firstAdminPath(can: (permission: string) => boolean): string | null {
  return adminGroups(can)[0]?.links[0]?.to ?? null;
}
